/*
  this component is being used in the group module related to the route /groups/view-all
  that is not being used anymore or is not stable on live.
*/
import React from 'react';
import { connect } from 'react-redux';
import CenterPanelCreate from './centerPanelCreate';
import RightPanelCreate from './rightPanelCreate';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelUpdate from './rightPanelUpdate';
import CenterPanelView from './centerPanelView';
import RightPanelView from './rightPanelView';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

@connect(mapStateToProps)
export default class CreateUpdateMeetingRoom extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      groups: props.groups,
      updateOrInsert: props.updateOrInsert,
      clickedUpdateMeetingRoom: props.meetingRoomForm.clickedUpdateMeetingRoom,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.setState({
      groups: props.groups,
      meetingRoomForm: props.meetingRoomForm,
      clickedUpdateMeetingRoom: props.meetingRoomForm.clickedUpdateMeetingRoom,
    });
  }

  openInsertHelp() {
    window.open(APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpCreate, '_blank');
  }
  openUpdateHelp() {
    window.open(APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpEditProperties, '_blank');
  }

  render() {
    let rightPanel = {};
    let centerPanel = {};
    let subtitle = undefined;
    let trimmedGroup = {};
    let orgName = this.props.meetingRoomForm.organisationAbbreviatedName;
    let parentGroupName = this.props.meetingRoomForm.parentGroupName;

    var updatingMeetingRoomName =
      this.props.headerName != undefined && this.props.headerName != ''
        ? this.props.headerName + ' (' + parentGroupName + ' / ' + orgName + ')'
        : '(/)';
    if (this.state.updateOrInsert == 'insert') {
      rightPanel = <RightPanelCreate meetingRoomForm={this.props.meetingRoomForm} />;
      centerPanel = <CenterPanelCreate groups={this.state.groups} meetingRoomForm={this.props.meetingRoomForm} />;
    } else if (this.state.updateOrInsert == 'update') {
      rightPanel = <RightPanelUpdate meetingRoomForm={this.props.meetingRoomForm} />;
      centerPanel = <CenterPanelUpdate groups={this.state.groups} meetingRoomForm={this.props.meetingRoomForm} />;
      subtitle = updatingMeetingRoomName;
    } else if (this.state.updateOrInsert == 'insertFromGroup') {
      rightPanel = <RightPanelCreate meetingRoomForm={this.props.meetingRoomForm} />;
      centerPanel = <CenterPanelCreate groups={this.state.groups} meetingRoomForm={this.props.meetingRoomForm} />;
      subtitle = this.props.meetingRoomForm.headerName;
    } else {
      rightPanel = <RightPanelView meetingRoomForm={this.props.meetingRoomForm} />;
      centerPanel = <CenterPanelView groups={this.state.groups} meetingRoomForm={this.props.meetingRoomForm} />;
      subtitle = this.props.meetingRoomForm.name + ' (' + orgName + ')';
    }

    let showModal = false;
    if (this.state.updateOrInsert == 'insert') showModal = this.props.showCreateMeetingRoomModal;
    else if (this.state.updateOrInsert == 'update') showModal = this.props.showUpdateMeetingRoomModal;
    else showModal = this.props.showViewMeetingRoomModal;

    return (
      <Modal show={showModal} hideWhenClickAway={true} className={this.state.updateOrInsert + '-meeting-room'}>
        <PopupHeader
          title={
            this.props.updateOrInsert && this.props.updateOrInsert.startsWith('insert')
              ? APP.LANGUAGE.CreateUpdateMeetingRoom.TitleCreate
              : APP.LANGUAGE.CreateUpdateMeetingRoom.TitleUpdate
          }
          subtitle={subtitle}
          helpFunc={this.props.updateOrInsert.startsWith('insert') ? this.openInsertHelp : this.openUpdateHelp}
        />
        <div className="content">
          <div className="main-ui-container meeting-room-create-update">
            <div id="righthandfloatingpanel">
              <div className="right ui rail">
                <div className="ui sticky">{rightPanel}</div>
              </div>
              {centerPanel}
              <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    headerName: state.meetingRoomReducer.meetingRoomForm.headerName,
    showCreateMeetingRoomModal: state.modalReducer.showCreateMeetingRoomModal,
    showUpdateMeetingRoomModal: state.modalReducer.showUpdateMeetingRoomModal,
    showViewMeetingRoomModal: state.modalReducer.showUpdateMeetingRoomModal,
  };
}
